import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { EmployeeProps } from 'src/@types/employee';
// @types
import { JobProps } from 'src/@types/job';
// components
import { Breadcrumbs } from 'src/components';
import Routes from 'src/routes';
import cssStyles from 'src/utils/cssStyles';
// utils
import { fDate } from 'src/utils/formatTime';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10),
  ...cssStyles(theme).bgImage(),
}));

// ----------------------------------------------------------------------

type Props = {
  job: JobProps;
};

export default function JobHero({ job }: Props) {
  const { title, job_title, expiration_date, contact } = job;

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <>
      <RootStyle>
        <Container>
          <Breadcrumbs
            onDark
            links={[
              { name: 'Hjem', href: '/' },
              { name: 'Stillinger', href: Routes.jobs },
              { name: job.title },
            ]}
            sx={{
              mb: { xs: 5, md: 8 },
            }}
          />

          <Stack
            spacing={5}
            direction={{ xs: 'column', md: 'row' }}
            justifyContent={{ md: 'space-between' }}
          >
            <Stack spacing={{ xs: 3, md: 2 }} sx={{ color: 'common.white' }}>
              <Typography variant="h3" component="h1">
                {title}
              </Typography>

              <Stack spacing={3} direction={{ xs: 'column', md: 'row' }} sx={{ opacity: 0.48 }}>
                <Typography>Stilling: {job_title}</Typography>
              </Stack>
            </Stack>

            <Stack
              spacing={2}
              direction="row"
              alignItems="flex-start"
              sx={{ width: 1, maxWidth: { sm: 340, xs: "100%" } }}
            >
              <Stack spacing={2} alignItems="center" sx={{ width: 1 }}>
                <Button onClick={handleClickOpen} fullWidth variant="contained" size="large">
                  Søk på stillingen
                </Button>
                <Typography variant="body3" sx={{ color: 'common.white' }}>
                  Søknadsfrist:{' '}
                  <Box component="span" sx={{ color: 'primary.main' }}>
                    {expiration_date ? fDate(expiration_date) : "Ansetter fortløpende"}
                  </Box>
                </Typography>
              </Stack>

            </Stack>
          </Stack>
        </Container>
      </RootStyle>
      <ApplicationDialog open={open} handleClose={handleClose} contact={contact} />
    </>
  );
}

interface DialogProps {
  handleClose: () => void
  open: boolean
  contact: EmployeeProps
}

function ApplicationDialog({ handleClose, open, contact }: DialogProps) {

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle>
          <Typography variant="h4" sx={{ mb: 3 }}>
            Hvordan søker jeg?
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="dialog-description">
            Ta kontakt med {contact.name} <br /> Tlf.: <b>{contact.phone}</b> eller email: <b>{contact.email}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="success" onClick={handleClose} autoFocus>
            Lukk
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
